import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AlertService } from '@client-libs';
import { AdminStore } from '../../../stores/admin.store';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css'],
  standalone: true,
  imports: [CommonModule, RouterLink],
})
export class TopBar {
  readonly alertService = inject(AlertService);
  readonly adminStore = inject(AdminStore);
  readonly router = inject(Router);

  user = this.adminStore.admin;
  header = input.required<string>();
  parentHeader = input<string>();
  description = input<string>();

  logout() {
    this.alertService
      .open({
        title: '로그아웃',
        content: '로그아웃 하시겠습니까?',
        type: 'info',
      })
      .closed.subscribe({
        next: async result => {
          if (result?.action === 'confirm') {
            await this.adminStore.logout();
            this.router.navigate(['/sign-in']);
          }
        },
      });
  }
}
